import React, { Component, createRef } from 'react';
import { Label, FormGroup, Input } from 'reactstrap';
import { getErrorMessage, hasErrorInScript } from './formErrorHelper';
import { FMessage } from '../../hoc/IntlComponents';

class StreamTDSScriptTitle extends Component {
  constructor(props) {
    super(props);
    this._alertRefs = {
        [props.errorPath]: createRef(),
    };
  }
  componentDidMount() {
    const {saveRef, errorPath, scrKey} = this.props;
    saveRef(true, errorPath, this._alertRefs[errorPath], scrKey);
  }
  hasError = () => {
    const {errors, scrKey, errorPath} = this.props;
    return hasErrorInScript({
      errors,
      errorPath,
      scrKey,
    });
  }
  render() {
    const {onChangeScriptTitle, scrKey, title, errorPath} = this.props;
    const error = this.hasError();
    return (
      <div
        ref={this._alertRefs[errorPath]}
        id={`${errorPath}${scrKey}`}
      >
        <FormGroup className={error ? 'has-error' : ''}>
          <Label for="flow-script-title">
            <FMessage id="flow.form.title"/>
          </Label>
          <Input
            id="flow-script-title"
            name="title"
            onChange={e => onChangeScriptTitle(e.target, scrKey)}
            value={title}
            autoComplete="off"
          />
          {error && <small className="form-text">{getErrorMessage(errorPath)}</small>}
        </FormGroup>
      </div>
    );
  }
}

export default StreamTDSScriptTitle;
